import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import MintUI from 'mint-ui'
import Picker from 'vant'
import 'vant/lib/index.css'
import 'mint-ui/lib/style.css'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(VueAxios, axios.create({
  baseURL: '/', // API 基础路径（可选）
  // baseURL: 'https://be0123.xn--c2be8bbg0fl3ewb.xn--i1b6b1a6a2e:8443/unite49/h5/stat', // API 基础路径（可选）
  timeout: 20000, // 请求超时时间（可选）
}));

Vue.use(MintUI)
Vue.use(Picker)

var app = new Vue({
  router,
  store,
  echarts,
  render: h => h(App)
}).$mount('#app')